import { ThemeProperties } from '../../core';

export interface TooltipTheme {
	basePadding: string;
	baseText: string;
	baseTextColor: string;
	baseBackground: string;
	baseElevation: string;
	baseBorderRadius: string;
	baseArrowMargin: string;
	darkBackground: string;
	darkTextColor: string;
	lightBackground: string;
	lightTextColor: string;
	interactiveBackground: string;
	interactiveTextColor: string;
	arrowSize: string;
	arrowBorderRadius: string;
}

export const theme = new ThemeProperties('tooltip');
